import { useParams, Link } from "react-router-dom";
import Stepper from "../../components/Stepper"; 

export default function EventoFeinsul() {
  const { id } = useParams();

  return (
    <div
      className="page-bg"
      style={{ backgroundImage: 'url("/imagens/FundoGeral.png")' }}
    >
      <div className="evento-wrapper">
        <div className="evento-detalhe">
          <h1>Selecione uma opção</h1>

          <div className="acoes">
            <Link to={`/termo-visitante/${id}`} className="acao-feinsul">
              Visitante
            </Link>

            <Link to={`/termo-expositor/${id}`} className="acao-feinsul">
              Expositor
            </Link>
          </div>
        </div>

        <Stepper etapaAtual={1} />
      </div>
    </div>
  );
}